import { render, staticRenderFns } from "./EpPromotionTargetCard.vue?vue&type=template&id=5ce3b945&"
import script from "./EpPromotionTargetCard.vue?vue&type=script&lang=js&"
export * from "./EpPromotionTargetCard.vue?vue&type=script&lang=js&"
import style0 from "./EpPromotionTargetCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports